/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomerAddressesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerAddressesQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly addresses: ReadonlyArray<{
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly city: string;
      readonly state: string;
      readonly country: string;
      readonly zipCode: string;
      readonly deliveryPreference: Types.DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly name: string | null;
      readonly notes: string | null;
    }>;
  } | null;
};

export const customerAddressesQueryMock: ExecutionResult<CustomerAddressesQuery> =
  {
    data: {
      currentCustomer: {
        id: 'e509e6ea-9fee-442a-9962-587ce7190430',
        addresses: [
          {
            id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
            street: 'Hello World',
            secondaryStreet: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            country: 'Hello World',
            zipCode: 'Hello World',
            deliveryPreference: 'CURBSIDE',
            googlePlaceId: 'Hello World',
            latitude: -47.4,
            longitude: -1.97,
            name: 'Hello World',
            notes: 'Hello World',
          },
          {
            id: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
            street: 'Hello World',
            secondaryStreet: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            country: 'Hello World',
            zipCode: 'Hello World',
            deliveryPreference: 'CURBSIDE',
            googlePlaceId: 'Hello World',
            latitude: -17.73,
            longitude: -57.58,
            name: 'Hello World',
            notes: 'Hello World',
          },
        ],
      },
    },
  };

export const CustomerAddressesDocument = gql`
  query CustomerAddresses {
    currentCustomer {
      id
      addresses {
        id
        street
        secondaryStreet
        city
        state
        country
        zipCode
        deliveryPreference
        googlePlaceId
        latitude
        longitude
        name
        notes
      }
    }
  }
`;

export function useCustomerAddressesQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerAddressesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(
    { query: CustomerAddressesDocument, ...options },
  );
}
